import React from "react";

export interface Props {
  name: string;
  img?: any;
  onClick?: () => void;
  className?: string; // Allow passing additional classNames
}

const ButtonElement: React.FC<Props> = ({ name, img, onClick, className = "" }) => {
  return (
    <div
      onClick={onClick}
      className={`inline-flex gap-2 items-center px-6 py-3 bg-white text-sm font-semibold text-gray-700 rounded-lg shadow-md hover:bg-main hover:text-white focus:outline-none focus:ring-2 focus:ring-main focus:ring-offset-2 transition-all duration-300 cursor-pointer w-full ${className}`}
    >
      {img && <div className="w-6 h-6">{img}</div>}
      <span className="ml-2">{name.toUpperCase()}</span>
    </div>
  );
};

export default ButtonElement;
